import constants from '@core/utils/constants'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    community: null,
    service: null,
    settings: {
      callManagementDisabled: false,
      callCardsAdvancedMode: false,
    },
  },
  getters: {
    currentCommunity: state => state.community,
    currentService: state => state.service,
    isCurrentServicePremium: state => state.service && state.service.plan === constants.SUBSCRIPTION_PLAN.PREMIUM,
    callManagementDisabled: state => state.settings.callManagementDisabled,
  },
  mutations: {
    selectCommunity(state, val) {
      state.community = val
    },
    selectService(state, val) {
      state.service = val

      if (val) {
        state.settings.callManagementDisabled = val.callManagementDisabled
        state.settings.name = val.name
        state.settings.icon = val.icon
        state.settings.timeout = val.timeout
        state.settings.associatedChannel = val.associatedChannel
        state.settings.onDutyRole = val.onDutyRole
        // state.settings.callCardsAdvancedMode = val.callCardsAdvancedMode
      }
    },
    updateSetting(state, { setting, value }) {
      if (setting === 'icon') {
        state.service.icon = value
      }
      if (setting === 'name') {
        state.service.name = value
      }

      state.settings[setting] = value
    },
  },
  actions: {
    GET_CONTEXT: ({ commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get('/auth/context')
          .then(res => {
            commit('selectCommunity', res.data.community)
            commit('selectService', res.data.service)

            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_COMMUNITIES: (_, { forceRefresh }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/me/communities${forceRefresh ? '?refresh=true' : ''}`)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    GET_SERVICES: ({ state }, { forceRefresh }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${state.community.id}/services${forceRefresh ? '?refresh=true' : ''}`)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    GET_SUBSCRIBED_STATS: ({ state }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${state.community.id}/subscribed-services-stats`)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    SELECT_COMMUNITY({ commit }, community) {
      commit('selectCommunity', community)
    },
    SELECT_SERVICE: ({ state, commit }, service) =>
      new Promise((resolve, reject) => {
        if (service) {
          Vue.prototype.$http
            .post('/auth/context', {
              communityId: state.community.id,
              serviceId: service.id,
            })
            .then(res => {
              commit('selectService', service)

              resolve(res)
            })
            .catch(err => reject(err))
        } else {
          commit('selectService', null)

          resolve(null)
        }
      }),
    UPDATE_SETTING: ({ state, commit }, { setting, value }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(`/v1/communities/${state.community.id}/services/${state.service.id}/settings`, {
            [setting]: value,
            isUpdatingEnabled: false,
          })
          .then(res => {
            commit('updateSetting', { setting, value })

            resolve(res)
          })
          .catch(err => reject(err))
      }),
    SET_SERVICE_SUBSCRIPTION_ID: ({ state, commit }, subscriptionId) => {
      commit('selectService', {
        ...state.service,
        plan: constants.SUBSCRIPTION_PLAN.PREMIUM,
        SubscriptionId: subscriptionId,
      })
    },
  },
}
